import { StatusModel } from '../../general';

export interface HexagonListModel {
  label: string;
  value: number;
  unit: string;
  utilisation: StatusModel;
  isActive?: boolean;
}
